import { isEmpty } from "lodash"
import { z } from "zod"
import {
  // isPossiblePhoneNumber,
  // validatePhoneNumberLength,
  parsePhoneNumber 
} from "libphonenumber-js"

const ERROR = {
  name: "Please enter a valid name",
  special: "Special charecter is not allowed",
  email: "Please enter a valid email address",
  telephone: "Please enter a valid phone number",
  message: "Please enter a valid message",
  propertyAddress: "Please enter a valid address",
  date: "Please enter a valid date",
  time: "Please enter a valid time",
  string: "Please enter a valid string",
  select: "Please select a valid option",
  number: "Please enter a valid number",
  jobTitle: "Please enter a valid job title",
  companyName: "Please enter a valid company name",
}

const SCHEMA = {
  name: z.string({ message: ERROR.name }).min(1, { message: ERROR.name }).regex(/^[\s,.a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>\?~`\-="']*$/, {
    message: ERROR.special
  }),
  emailContent: z.string({ message: ERROR.message }),
  email: z.string().email({ message: ERROR.email }),
  telephone: z
    .string({ message: ERROR.telephone })
    .min(1, { message: ERROR.telephone })
    // .refine(
    //   (value) => {
    //     return (
    //       !!value &&
    //       !validatePhoneNumberLength(`+${value}`) &&
    //       isPossiblePhoneNumber(`+${value}`)
    //     )
    //   },
    //   (value) => {
    //     let message = ""
    //     const res = validatePhoneNumberLength(`+${value}`)

    //     switch (res) {
    //       case "NOT_A_NUMBER":
    //         message = "Please enter a valid phone number"
    //         break
    //       case "INVALID_COUNTRY":
    //         message = "Invalid country code"
    //         break
    //       case "TOO_SHORT":
    //         message = "Phone number is too short"
    //         break
    //       case "TOO_LONG":
    //         message = "Phone number is too long"
    //         break
    //       case "INVALID_LENGTH":
    //         message = "Please enter a valid phone number"
    //         break
    //       default:
    //         message = "Please enter a valid phone number"
    //         break
    //     }

    //     return {
    //       message,
    //     }
    //   }
    // ),
    .refine(
      (value) => {
        try {
          const phoneNumberObject = parsePhoneNumber(`+${value}`);
          return phoneNumberObject.isValid();
        } catch {
          return false;
        }
      },
      {
        message: "Please enter a valid phone number",
      }
    ),
  message: z.string({ message: ERROR.message }).regex(/^[\s,.a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>\?~`\-="']*$/, {
    message: ERROR.message
  })
  .nullable(),
  propertyAddress: z.string({ message: ERROR.propertyAddress }).regex(/^[\s,.a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>\?~`\-="']*$/, {
    message: ERROR.propertyAddress
  })
  .nullable(),
  date: z.string({ message: ERROR.date }),
  time: z.string({ message: ERROR.time }),
  attachment: z
    .any()
    .refine((files) => !isEmpty(files), "Please upload a file.")
    .refine((files) => files?.[0]?.size <= 5000000, "Max file size is 5MB."),
  nationality: z
    .string({ message: ERROR.name })
    .min(1, { message: ERROR.name }),
  string: z.string({ message: ERROR.string }).min(1, { message: ERROR.string }),
  stringArray: z.array(z.string({ message: ERROR.string })),
  select: z.string({ message: ERROR.select }).min(1, { message: ERROR.select }),
  selectInt: z.number({ message: ERROR.select }),
  number: z.number({ message: ERROR.number, invalid_type_error: ERROR.number }),
  jobTitle: z
    .string({ message: ERROR.jobTitle })
    .min(1, { message: ERROR.jobTitle }),
  companyName: z
    .string({ message: ERROR.companyName })
    .min(1, { message: ERROR.companyName }),
  // .refine(
  //   files => ACCEPTED_IMAGE_TYPES.includes(files?.[0]?.type),
  //   ".jpg, .jpeg, .png and .webp files are accepted."
  // ),
}

export const newsletterSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  emailContent: SCHEMA.emailContent
})
export const brochureSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  language: SCHEMA.selectInt,
  emailContent: SCHEMA.emailContent
})

export const finiancialSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  language: SCHEMA.selectInt,
  emailContent: SCHEMA.emailContent
})
export const registerInterestSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  language: SCHEMA.selectInt,
  needFiniancialAdvice: z.boolean().optional(),
  emailContent: SCHEMA.emailContent,
  message: SCHEMA.message
})

export const contactSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  language: SCHEMA.selectInt,
  needFiniancialAdvice: z.boolean().optional(),
  emailContent: SCHEMA.emailContent,
  message: SCHEMA.message
})

export const cpSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  language: SCHEMA.selectInt,
  cemail: SCHEMA.selectInt,
  needFiniancialAdvice: z.boolean().optional(),
  emailContent: SCHEMA.emailContent,
  message: SCHEMA.message
})

export const questionnaireSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  language: SCHEMA.selectInt,
  needFiniancialAdvice: z.boolean().optional(),
  emailContent: SCHEMA.emailContent
})

export const teamContactSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  message: SCHEMA.message,
  language: SCHEMA.selectInt,
  emailContent: SCHEMA.emailContent
})

export const downloadReportSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  emailContent: SCHEMA.emailContent
})

export const offMarketSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  language: SCHEMA.selectInt,
  budget: SCHEMA.number,
  size: SCHEMA.string,
  location: SCHEMA.string,
  message: SCHEMA.message,
  propertyType: SCHEMA.selectInt,
  offMarketPurpose: SCHEMA.selectInt,
  emailContent: SCHEMA.emailContent
})

export const sendCVSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  language: SCHEMA.selectInt,
  message: SCHEMA.message,
  attachment: SCHEMA.attachment,
  emailContent: SCHEMA.emailContent
})

export const enquirySchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  language: SCHEMA.selectInt,
  message: SCHEMA.message,
  emailContent: SCHEMA.emailContent
})

export const bookViewingSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  date: SCHEMA.date,
  time: SCHEMA.time,
  language: SCHEMA.selectInt,
  message: SCHEMA.message,
  needFiniancialAdvice: z.boolean().optional(),
  emailContent: SCHEMA.emailContent
})

export const bookViewingMiniSchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  message: SCHEMA.message,
  emailContent: SCHEMA.emailContent
})

export const listPropertySchema = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  propertyAddress: SCHEMA.propertyAddress,
  propertyType: SCHEMA.selectInt,
  propertyPurpose: SCHEMA.selectInt,
  bedroomCount: SCHEMA.selectInt,
  language: SCHEMA.selectInt,
  message: SCHEMA.message,
  emailContent: SCHEMA.emailContent
})


export const brightCallSchema = z.object({
  name: SCHEMA.name,
  telephone: SCHEMA.telephone
})